import { chakra } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import type { PropsWithChildren } from 'react';

import { useContainerStyles } from './';

export type ContainerBodyProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerBody = ({ children, ...props }: ContainerBodyProps) => {
  const styles = useContainerStyles();

  return (
    <chakra.div __css={styles.containerBody} {...props}>
      {children}
    </chakra.div>
  );
};
ContainerBody.displayName = 'ContainerBody';
